/**
 * @fileoverview Profile components for user profile management
 * 
 * @purpose Provides reusable profile components for user profile display, editing,
 *          and management. Includes avatar upload, profile editing, activity history,
 *          and privacy controls.
 * 
 * @usage Import in app components:
 *        import { UserProfile, ProfileEditForm, AvatarUpload } from '@korvo/core/components/profile'
 * 
 * @ownership Core infrastructure - profile components
 */

export { ActivityHistory } from './ActivityHistory'
export { AvatarUpload } from './AvatarUpload'
export { EmailChangeForm } from './EmailChangeForm'
export { MobileProfileHeader } from './MobileProfileHeader'
export { ModuleAnalytics } from './ModuleAnalytics'
export { PasswordChangeForm } from './PasswordChangeForm'
export { PrivacyControls } from './PrivacyControls'
export { ProfileCompletion } from './ProfileCompletion'
export { ProfileEditForm } from './ProfileEditForm'
export type { UserProfileSlots } from './UserProfile'
export { UserProfile } from './UserProfile'
